import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { addHours, isPast, minutesToMilliseconds } from 'date-fns';

import { getRecordingsCache } from 'store/recordings/actions';
import { getRecordingsCacheSyncTime } from 'store/recordings/selectors';

function useRecordingsCache() {
    const dispatch = useDispatch();
    const interval = useRef<NodeJS.Timeout | null>(null);

    const lastSyncTime = useSelector(getRecordingsCacheSyncTime);

    useEffect(() => {
        if (lastSyncTime != null) {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }

            interval.current = setInterval(() => {
                if (isPast(addHours(lastSyncTime, 3))) {
                    dispatch(getRecordingsCache());
                }
            }, minutesToMilliseconds(1));
        }

        return () => {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }
        };
    }, [lastSyncTime]);
}

export default useRecordingsCache;
